import PropTypes from 'prop-types';
import React from 'react';

export default function CompactText({compactText, children}) {
  require("./CompactText.scss");

  return (compactText
    ?<span data-compact-text={compactText}><span>{children}</span></span>
    :<span>{children}</span>
  )
}

CompactText.propTypes = {
  compactText: PropTypes.string,
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./modules/Common/components/CompactText.js